export const SET_SNACKBAR = 'SET_SNACKBAR';
